/** Public hosted API address shared by company pages and optional support. */
export const API_BASE = (import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');
